export default __webpack_public_path__ + "static/media/Group 11949.da0a1e3b.svg";